// Firebase app configuration.
const config = {
    // Past your configuration here from Google Firebase
    apiKey: "AIzaSyCva2SQZbcyXQbf9vlHmbpJBk77AikgoB4",
    authDomain: "fuelcrowd19.firebaseapp.com",
    databaseURL: "https://fuelcrowd19.firebaseio.com",
    projectId: "fuelcrowd19",
    storageBucket: "gs://fuelcrowd19.appspot.com/",
    messagingSenderId: "526950178741",
    appId: "1:526950178741:web:cc8d42ec08c1809e"
}

export default config;



// WEBPACK FOOTER //
// ./src/firebase/config.js